import "@/businessLogicRegistry";
import { ConfigWrapper } from "@/components/ConfigWrapper";
import { ThemeProvider } from "@/context/ThemeContext";
import "@/i18n";
import "@/instrument";
import "@/styles/index.css";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
// eslint-disable-next-line import/no-unresolved
import { registerSW } from "virtual:pwa-register";

registerSW({ immediate: true });

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ThemeProvider>
      <ConfigWrapper />
    </ThemeProvider>
  </StrictMode>
);
